<div class="container-fluid p-0 m-0">
    <app-shared status="Livré"></app-shared>
</div>
